<div class="title">
	<h1>Param&eacute;trage des responsabilit&eacute;s</h1>
	<label class="radio-inline">
		<input type="radio"
			name="resp"
			id="resp_CAC"
			[value]="'CAC'"
			required
			[ngModel]="responsabilite$ | async"
			(ngModelChange)="responsabiliteHasChanged('CAC')"
		/>
		CAC
	</label>
	<label class="radio-inline">
		<input type="radio"
			name="resp"
			id="resp_CC"
			[value]="'CC'"
			required
			[ngModel]="responsabilite$ | async"
			(ngModelChange)="responsabiliteHasChanged('CC')"
		/>
		CC
	</label>
</div>
<pannel
	[title]="title"
	[expandable]="true"
	[folded]="false" 
	>
	<form role="form" class="form-horizontal">
		<div class="row">
			<div class="form-group col-sm-12">
				<antenne-selector
					[id]="'eantenne'"
					[mandatory]="true"
					[labelClass]="'col-md-2'"
					[fieldClass]="'col-md-4'"
					[wildcardOptionLabel]="null"
					[resetCommands]="resetAntenneCommands$"
					(selectedAntenneChange)="antenneId$.next($event === null ? null : $event.id)"
					>
				</antenne-selector>
			</div>
		</div>
		<div class="row">
			<div class="form-group col-sm-12">
				<label class="col-sm-2 control-label" for="pexploitant">Exploitant&nbsp;: </label>
				<div class="col-sm-4">
					<filterable-select
						[id]="'pexploitant'"
						[inputClass]="'form-control'"
						[disabled]="disableCandidatSelector"
						[keyGetter]="getUserKey"
						[labelGetter]="getUserLabel"
						[list]="candidats"
						[resetCommand]="candidatSelectorResetCommand" 
						[selectedItem]="responsable$ | async"
						(selectedItemChange)="responsable$.next($event)"
						>
					</filterable-select>
				</div>
			</div>
		</div>
	</form>
</pannel>
<pannel
	[title]="'Le p&eacute;rim&egrave;tre'"
	[expandable]="true"
	[folded]="false" 
	>
	<form role="form" class="form-horizontal">
		<div class="form-group">
			<label class="col-md-2 control-label" for="transfertComplet">P&eacute;rim&egrave;tre de transfert&nbsp;: </label>
			<div class="col-md-1 plus-half">
				<label class="radio-inline">
					<input type="radio"
						name="transfertComplet"
						id="transfertComplet_oui"
						[value]="true"
						required
						[ngModel]="transfertComplet$ | async"
						(ngModelChange)="transfertComplet$.next(true)"
					/>
					Complet
				</label>
				<label class="radio-inline">
					<input type="radio"
						name="transfertComplet"
						id="transfertComplet_non"
						[value]="false"
						required
						[ngModel]="transfertComplet$ | async"
						(ngModelChange)="transfertComplet$.next(false)"
					/>
					Partiel
				</label>
			</div>
		</div>
		<perimetre-selector
			*ngIf="!(transfertComplet$ | async)"
			[antenneId]="antenneId$ | async"
			[dataExtraction]="perimetreDataExtraction$"
			[hyperviseurFilterEnabled]="true"
			[transfertPartiel]="!(transfertComplet$ | async)"
			>
		</perimetre-selector>
		<div class="form-group text-center action-button">
			<button
				type="submit"
				class="btn btn-success"
				[disabled]="validationButtonDisabled$ | async"
				(click)="validation$.next()"
				>
				Param&eacute;trer
			</button>
		</div>
	</form>
</pannel>
